<template>
	<v-main>
		<v-navigation-drawer fixed clipped permanent style="padding: 64px 0px 0px 0px;">
			<v-card flat>
				<v-card-text>
					<div class="textcaption">Фото</div>
					<v-row>
						<v-col v-for="(file, index) in item.files" :key="index"
							class="d-flex child-flex"
							cols="4"
						>
							<v-menu absolute offset-y>
								<template v-slot:activator="{ on, attrs }">
									<v-img v-bind="attrs" v-on="on"
										:src="getFileUrl(file)"
										aspect-ratio="1"
										class="grey lighten-2"
									></v-img>
									<!-- 
									:src="file.src"
									:src="getFileUrl(file)"
									-->
									<!-- <v-card
										class="portrait"
										img="https://cdn.vuetifyjs.com/images/cards/girl.jpg"
										height="300"
										width="600"
										v-bind="attrs"
										v-on="on"
									></v-card> -->
								</template>

								<v-list>
									<v-list-item>
										<v-list-item-avatar>
											<v-icon v-if="file.type=='image/png'" v-text="'mdi-file-png-box'"></v-icon>
											<v-icon v-else-if="file.type=='image/jpeg'" v-text="'mdi-file-jpg-box'"></v-icon>
											<v-icon v-else v-text="'mdi-image'"></v-icon>											
										</v-list-item-avatar>
										<v-list-item-content>
											<v-list-item-title class="text-h5">{{ file.name }}</v-list-item-title>
											<v-list-item-subtitle>{{ file.size }} {{ file.type }}</v-list-item-subtitle>
										</v-list-item-content>
										<!-- <v-list-item-action>
											<v-icon>mdi-menu-down</v-icon>
										</v-list-item-action> -->
									</v-list-item>
								</v-list>

								<v-divider></v-divider>

								<v-list>
									<z-gallery :items="files" :selected-index="index">
										<template v-slot:activator="{ dialog, attrs }">
											<v-list-item v-bind="attrs" v-on="dialog">
												<v-list-item-icon>
													<v-icon v-text="'mdi-view-gallery'"></v-icon>
												</v-list-item-icon>
												<v-list-item-content>
													<v-list-item-title v-text="'Галерея'"></v-list-item-title>
												</v-list-item-content>
											</v-list-item>
										</template>	
									</z-gallery>
									<v-list-item @click="removeFile(file)">
										<v-list-item-icon>
											<v-icon v-text="'mdi-delete'"></v-icon>
										</v-list-item-icon>
										<v-list-item-content>
											<v-list-item-title v-text="'Видалити'"></v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</v-list>
							</v-menu>
						</v-col>
						<v-col cols="12" class="text-center">
							<v-btn icon x-large text @click="$refs.fileinput.$refs.input.click()">
								<v-icon>mdi-paperclip-plus</v-icon>
							</v-btn>
						</v-col>
					</v-row>
					
					<v-combobox
						v-model="prompt"
						:items="prompts"
						label="Тип оцінки"
						outlined
						dense
						item-text="name"
						item-value="id"
						hide-details="auto"
						class="my-3"
					></v-combobox>

					<div v-if="isAdmin">
						<v-divider class="my-3"></v-divider>
						<v-textarea
							v-model="promptCustom"
							outlined
							label="Альтернативний промпт"
							dense
							hide-details="auto"
						></v-textarea>
						<v-divider class="my-3"></v-divider>
						<div class="text-caption font-weight-bold">Згенерований промпт:</div>
						<div class="text-caption">{{ promptText }}</div>
					</div>
				</v-card-text>
			</v-card>
			<template v-slot:append>
				<v-card-actions class="px-4">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="onClear">{{ $vuetify.lang.t('$vuetify.clear') }}</v-btn>
					<v-btn color="primary" @click="onOK">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
				</v-card-actions>
			</template>
		</v-navigation-drawer>

		<v-navigation-drawer fixed clipped permanent right floating
			mini-variant
			mini-variant-width="56"
			style="padding: 64px 0px 0px 0px;"
        >
			<!-- <v-list dense nav>
				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon v-bind="attrs" v-on="{ ...tooltip }" @click="onLoad">mdi-folder</v-icon>
							</template>
							<span>Завантажити</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>
				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon v-bind="attrs" v-on="{ ...tooltip }" @click="onSave">mdi-content-save</v-icon>
							</template>
							<span>Зберегти</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>
			</v-list>

			<v-divider></v-divider> -->

			<v-list dense nav>
				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon color="red" v-bind="attrs" v-on="{ ...tooltip }" @click="onPDF">mdi-file-pdf-box</v-icon>
							</template>
							<span>Експорт PDF</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>
			</v-list>
        </v-navigation-drawer>

        <v-container style="padding: 64px 0px 0px 256px;">
			<v-card flat>
				<v-card-title class="text-h5">{{ title }}</v-card-title>
				<v-card-subtitle>{{ subtitle }}</v-card-subtitle>
				<v-divider></v-divider>
				<v-card-text v-html="item.outputHtml"></v-card-text>
			</v-card>
		</v-container>

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>

		<v-snackbar v-model="snackbar.visible">
			{{ snackbar.text }}
			<template v-slot:actions>
				<v-btn icon="mdi-window-close" @click="snackbar.visible = false"></v-btn>
			</template>
		</v-snackbar>

		<v-file-input
			v-model="file"
			ref="fileinput"
			class="d-none"
			multiple
			accept="image/png;image/jpeg;image/webp;image/heic;image/heif"
			@change="changeFile"
		></v-file-input>

		<v-file-input
			v-model="filedata"
			ref="filedata"
			class="d-none"
			accept="application/json"
			@change="changeFileData"
		></v-file-input>

		<z-pdf ref="pdf" :item="pdf"></z-pdf>
    </v-main>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import zPdf from '@/views/pdf/VehicleInspectionAI'
import zGallery from '@/views/components/dialogs/Gallery'

export default {
	name: 'VehicleInspectionAI',
	//mixins: [mixin],
	components: {
		zPdf, zGallery
	},
	data: () => ({
		title: 'Огляд з ШІ',
		subtitle: 'Сервіс огляду транспортного засобу за допомогою штучного інтелекту',
		icon: 'mdi-image-auto-adjust',
		loading: false,

		filedata: null,
		file: null,

		prompt: {},
		prompts: [
			{ id: 1, code: 'MarketValue', name: 'Ринкова вартість', description: 'Експертна оцінка ринкової вартості ТЗ',
				text: "Роль: Ти — провідний аналітик автомобільного ринку та сертифікований оцінювач із досвідом роботи в інспекційних сервісах (наприклад, як у Auto1, Copart або офіційних дилерів). Твоє завдання — визначити справедливу ринкову вартість (Market Value) автомобіля на основі наданих фотографій та поточних даних ринку. АЛГОРИТМ ОЦІНКИ: Детальна ідентифікація: * Визнач точну модель, покоління (рестайлінг/дорестайлінг) та тип кузова. Знайди ознаки комплектації (типи фар, люк, розмір дисків, оздоблення салону, наявність асистентів водія), що суттєво впливають на ціну. Аналіз стану (Коригування ціни): Оціни візуальний стан: чи виглядає авто «доглянутим» або «втомленим». Врахуй виявлені дефекти (з попереднього аналізу) як фактори уцінки. Перевір відповідність пробігу до стану органів керування (кермо, сидіння). Аналіз ринку: Проаналізуй діапазон цін на аналогічні авто (модель/рік/двигун) на провідних майданчиках (Auto.ria, RST, Mobile.de). Врахуй фактор ліквідності: наскільки швидко продаються такі моделі. ФОРМАТ ЗВІТУ: 💰 ЗВІТ ПРО РИНКОВУ ВАРТІСТЬ ТЗ 1. Характеристики об'єкта: Визначена комплектація: (Base / Mid / Full / Luxury — обґрунтуй на основі побачених опцій). Сильні сторони (Опції, що додають вартості): (Наприклад: шкіряний салон, панорама, LED-оптика). 2. Фактори впливу на ціну: Позитивні: (Малий пробіг, рідкісний колір, ідеальний стан салону). Негативні: (Сліди ДТП, знос шин, необхідність фарбування, помилки на панелі). 3. Розрахунок вартості: Ціна ідеального аналога: [Сума] Сума коригування (уцінка за стан): - [Сума] Рекомендована ціна продажу (Середня): [Сума] Діапазон «Швидкий продаж»: [Сума] — [Сума]4. Прогноз ліквідності:Наскільки популярна ця модель зараз? Як швидко її можна реалізувати за вказаною ціною?Налаштування: * Валюта: [Вкажіть: USD/Гривня/Euro].Регіон ринку: [Вкажіть: Україна / США / ЄС]. Якщо фотографій недостатньо для точного визначення комплектації, зроби припущення, але вкажи на це."
			},
			{ id: 2, code: 'Calculation', name: 'Калькуляція ремонту', description: 'Експертний акт огляду ТЗ та калькуляція ремонту',
				text: "Роль: Ти — провідний сертифікований судовий експерт-автотехнік та оцінювач із 15-річним досвідом. Твоє завдання — провести професійний візуальний аудит автомобіля на основі наданих фотографій та сформувати «Акт огляду транспортного засобу» з орієнтовним розрахунком вартості відновлення.Твоя мета: Виявити всі видимі дефекти (вм’ятини, подряпини, різнотон, порушення геометрії зазорів, знос салону) та надати економічне обґрунтування для торгу або ремонту.ІНСТРУКЦІЇ З АНАЛІЗУ:Екстер'єр: Аналізуй зазори кузовних панелей, стан лакофарбового покриття (ЛФП), наявність корозії, стан оптики та маркування скла.Інтер'єр: Оціни знос керма, сидінь та педалей на відповідність заявленому пробігу. Перевір панель приладів на наявність помилок (Check Engine, Airbag тощо).Технічні деталі: Визнач стан гуми (маркування, сезонність), гальмівних дисків та підкапотного простору (підтікання, стан кліпс).СТРУКТУРА ЗВІТУ:📋 АКТ ОГЛЯДУ ТРАНСПОРТНОГО ЗАСОБУ1. Ідентифікація ТЗ:Марка/Модель/Рік: [Визначити за фото]VIN-код / Номерний знак: [Зчитати з фото]Пробіг (одометр): [Зчитати з фото]2. Візуальний стан кузова та салону:Опиши всі знайдені дефекти ЛФП, пошкодження пластику, стан дисків та оптики.Оціни відповідність стану салону до пробігу.3. Розрахунок вартості відновлювального ремонту:Використовуй середні ціни спеціалізованих СТО України.ДетальПошкодженняДія (Ремонт/Заміна/Фарбування)Робота ($/₴)Запчастини ($/₴)ВсьогоНазваОписМетодСумаСумаСумаРАЗОМ:[Сума]4. Висновок експерта:Загальний бал: (від 1 до 10).Критичні зауваження: (Наприклад: ознаки серйозного ДТП, спрацювання безпеки).Рекомендації: Що потребує негайної уваги, а що є природним зносом.Налаштування тону: Пиши професійно, використовуючи термінологію (шагрень, арматурні роботи, нормо-години, зазори). Якщо якість фото не дозволяє побачити деталь — вкажи: «Потребує додаткового фото з іншого ракурсу»."
			},

			{ id: 3, code: 'ForensicAnalyst', name: 'Експертиза зображень', description: 'Експертиза автентичності та технічної єдності фото',
				text: "Роль: Ти — старший експерт із цифрової криміналістики та аналізу зображень. Твоя спеціалізація — виявлення маніпуляцій, ознак генерації штучним інтелектом (AI-generated) та встановлення ідентичності пристрою зйомки за непрямими ознаками. Твоя мета: Визначити, чи є надані фотографії «живими» (реальними), а не створеними нейромережами (DALL-E, Midjourney, Stable Diffusion). Підтвердити, що всі надані фото зроблені одним і тим самим фізичним пристроєм (одним сенсором та об'єктивом). ІНСТРУКЦІЇ З АНАЛІЗУ 1. Перевірка на ознаки ШІ (AI Detection) Аналіз текстур: Шукай неприродну «замиленість» шкіри, дивні переходи у волоссі, траві або складних фонових візерунках. Геометрія та анатомія: Перевір правильність ліній, симетрію об'єктів (наприклад, фар автомобіля, коліс) та коректність відображення дрібних деталей (текст, цифри, руки). Закони оптики: Перевір реалістичність глибини різкості (bokeh). Чи відповідає розмиття фону фокусній відстані? Чи є артефакти на межі між об'єктом та фоном? Світло та тіні: Чи мають всі тіні єдине джерело світла? Шукай фізичні нестиковки у відблисках (на склі, металі, в очах). 2. Перевірка на єдність пристрою (Single Device Consistency) Параметри сенсора: Проаналізуй рівень та структуру цифрового шуму (grain) у темних зонах. Він має бути ідентичним на всіх фото. Оптичні характеристики: Порівняй дисторсію (викривлення по краях) та хроматичні аберації (кольорові контури). Колірна наука (Color Science): Чи ідентична передача відтінків шкіри (skintone) та баланс білого на всіх знімках за схожих умов освітлення? Метадані (якщо доступні): Порівняй EXIF-дані: модель камери, діафрагму, ISO, версію ПЗ. ФОРМАТ ВИСНОВКУ: 🔍 ЕКСПЕРТНИЙ ВИСНОВОК АВТЕНТИЧНОСТІ 1. Вердикт щодо реалістичності: Оцінка: (Реальне фото / Можлива генерація / 100% AI). Аргументи: Перелік знайдених артефактів або підтверджень реальності (наприклад, «присутній природний шум матриці», «коректне відображення тексту»). 2. Аналіз єдності пристрою: Висновок: (Всі фото зроблені одним пристроєм / Використовувалися різні пристрої). Докази: (Схожість лінзових спотворень, ідентичність роздільної здатності та зернистості). 3. Виявлені аномалії: (Наприклад: «На фото №2 спостерігається інша структура шуму», «На фото №1 дивні відблиски на склі, нехарактерні для поточної сцени»). 4. Рівень впевненості експерта: (0-100%). Налаштування: Будь максимально прискіпливим. Якщо ти бачиш ідеально «гладке» зображення без цифрового шуму — це привід для підозри. Якщо фото виглядають занадто «кінематографічно» — перевір фізику світла."
			},
		],
		promptCustom: null,

		snackbar: {
			visible: false,
			text: null
		},
	}),
	
	computed: {
		...mapGetters([ 'roles' ]),
		...mapGetters('VehicleInspectionAI', [ 'item' ]),

		isAdmin() {
			return this.roles.includes('ADMIN')
		},

		pdf() {
			return {
				datecreate: new Date(),
				title: this.title,
				filename: this.title,
				files: this.item.files,
				content: this.item.outputHtml
			}
		},

		files() {
			return this.item?.files ? this.item.files : []
		},

		promptText() {
			//let prompt = "Проаналізуй, що зображено на зображеннях"
			//let prompt = "Проаналізуй фото транспортного засобу як експерт по оцінці і визнач марку, модель, рік випуску, реєстраційний номер, пробіг, а також середню вартість в Україні в доларах та гривнях"
			//let prompt = "Роль: Ти — провідний сертифікований судовий експерт-автотехнік та оцінювач із 15-річним досвідом. Твоє завдання — провести професійний візуальний аудит автомобіля на основі наданих фотографій та сформувати «Акт огляду транспортного засобу» з орієнтовним розрахунком вартості відновлення.Твоя мета: Виявити всі видимі дефекти (вм’ятини, подряпини, різнотон, порушення геометрії зазорів, знос салону) та надати економічне обґрунтування для торгу або ремонту.ІНСТРУКЦІЇ З АНАЛІЗУ:Екстер'єр: Аналізуй зазори кузовних панелей, стан лакофарбового покриття (ЛФП), наявність корозії, стан оптики та маркування скла.Інтер'єр: Оціни знос керма, сидінь та педалей на відповідність заявленому пробігу. Перевір панель приладів на наявність помилок (Check Engine, Airbag тощо).Технічні деталі: Визнач стан гуми (маркування, сезонність), гальмівних дисків та підкапотного простору (підтікання, стан кліпс).СТРУКТУРА ЗВІТУ:📋 АКТ ОГЛЯДУ ТРАНСПОРТНОГО ЗАСОБУ1. Ідентифікація ТЗ:Марка/Модель/Рік: [Визначити за фото]VIN-код / Номерний знак: [Зчитати з фото]Пробіг (одометр): [Зчитати з фото]2. Візуальний стан кузова та салону:Опиши всі знайдені дефекти ЛФП, пошкодження пластику, стан дисків та оптики.Оціни відповідність стану салону до пробігу.3. Розрахунок вартості відновлювального ремонту:Використовуй середні ціни спеціалізованих СТО України.ДетальПошкодженняДія (Ремонт/Заміна/Фарбування)Робота ($/₴)Запчастини ($/₴)ВсьогоНазваОписМетодСумаСумаСумаРАЗОМ:[Сума]4. Висновок експерта:Загальний бал: (від 1 до 10).Критичні зауваження: (Наприклад: ознаки серйозного ДТП, спрацювання безпеки).Рекомендації: Що потребує негайної уваги, а що є природним зносом.Налаштування тону: Пиши професійно, використовуючи термінологію (шагрень, арматурні роботи, нормо-години, зазори). Якщо якість фото не дозволяє побачити деталь — вкажи: «Потребує додаткового фото з іншого ракурсу»."

			//return this.promptCustom ? this.promptCustom : prompt;
			return this.promptCustom ? this.promptCustom : this.prompt.text;
		},
	},

	created() {
		this.prompt = this.prompts[0]
	},

	methods: {
		...mapActions('VehicleInspectionAI', [ 'setItem' ]),

		showMessage(text, type) {
			this.snackbar.text 		= text;
			this.snackbar.visible 	= true;
			this.snackbar.color 	= null;
		},

		onPDF () {
			//console.log(this.$options.name, 'onPDF','pdf', this.pdf)
			this.$refs.pdf.generate()
		},

		onClear() {
			//console.log(this.$options.name, 'onClear', 'files', this.files)

			this.item.files = []
		},

		onOK() {
			if(this.item.files.length) {
				this.find()
			} else {
				this.showMessage('Не завантажено жодного фото', 'warning')
			}
		},

		getFileUrl(file) {
			return URL.createObjectURL(file);
		},

		removeFile(file) {
			const index = this.item.files.indexOf(file)
			this.item.files.splice(index, 1);
		},

		changeFile(e) {
			//console.log(this.$options.name, 'changeFile', 'e', e)
			if(e) {
				if(Array.isArray(e)) {
					e.forEach((element) => {
						this.addFile(element)
					})
				} else {
					this.addFile(e)
				}
			}

			this.file = null
		},

		addFile(file) {
			//console.log(this.$options.name, 'addFile', 'source', source, 'file', file)
			if(file) {
				this.item.files.push(file)
				/* this.item.files.push({
					name: file.name,
					size: file.size,
					type: file.type,
					src: URL.createObjectURL(file),
					content: file.text(),
				}) */
			}
		},

		find() {
			let text = this.promptText

			let formData = new FormData();
			formData.append('text', text );

			this.item.files.forEach((file, index) => {
				formData.append(`file${index}`, file);
			})

			var that = this
			this.loading = true
			return axios.post(`/vehicle/inspection/ai`, formData, {
				headers: {
					"Content-Type": "multipart/form-data"
				}
			}).then(response => {
				//console.log(that.$options.name, 'gemini','response.data', response.data)
				that.item.outputHtml = response.data
			}, error => {
				console.log('error', error)
				that.showMessage(error.response.data.message, 'error')
			}).finally(() => {
				this.loading = false
			});
		},

		/**
		 * Завантаження файлу
		 * Load JSON
		 */
		onLoad() {
			this.filedata = null
			this.$refs.filedata.$refs.input.click()
		},

		changeFileData (e) {
			const file = this.filedata;
			if (file) {
				const reader = new FileReader();
				reader.onload = (e) => {
					try {
						const item = JSON.parse(e.target.result);

						//console.log(this.$options.name, 'changeFileData','item', item)

						this.setItem(item)
					} catch (error) {
						//console.error("Error parsing JSON:", error);
						//this.jsonData = null; // Clear data on error
						alert("Invalid JSON file.");
					}
				};

				reader.readAsText(file);
			} else {
				//this.jsonData = null; // Clear data if no file selected
			}
		},

		/**
		 * Збереження файлу Налаштувань
		 * Save JSON
		 */
		onSave() {
			//console.log(this.$options.name, 'onSave','item', this.item)

			const filename = `${this.$options.name}.json`;
			const text = JSON.stringify(this.item);

			//console.log(this.$options.name, 'onSave','text', text)

			const blob = new Blob([text], { type: 'application/json' });
			const url = URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.download = filename;
			document.body.appendChild(a);
			a.click();

			document.body.removeChild(a);
			URL.revokeObjectURL(url);
		},

		/**
		 * Converts a File or Blob object to a Base64 string
		 * @param {File} file 
		 * @returns {Promise<string>}
		 */
		fileToBase64(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.readAsDataURL(file);
				reader.onload = () => resolve(reader.result);
				reader.onerror = (error) => reject(error);
			});
		},

		/**
		 * Converts a Base64 string back to a File object
		 * @param {string} base64String - The full data URL (data:image/png;base64,...)
		 * @param {string} filename - The name to give the file
		 * @returns {File}
		 */
		base64ToFile(base64String, filename) {
			// 1. Split the header from the data
			const arr = base64String.split(',');
			const mime = arr[0].match(/:(.*?);/)[1];
			const bstr = atob(arr[1]); // Decode base64
			
			// 2. Create a buffer
			let n = bstr.length;
			const u8arr = new Uint8Array(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}

			// 3. Construct the File object
			return new File([u8arr], filename, { type: mime });
		},
	},
}
</script>